// Will run beforeEach
export const guardRoute = (route, redirect, next) => {
  // Resource: https://goo.gl/MsK7bY
  // Check if user is authenticated
  const isAuthenticated = localStorage.getItem('user_details') !== null

  // Allow Anonymous
  if (route.matched.some(record => record.meta.allowAnonymous)) {
    next()
  } else if (!isAuthenticated) { // Not authenticated
    next('/login')
  } else if (isAuthenticated) { // Authenticated
    next()
  }
}

// Routes
// Note: The component functions, which returns the "require", is a must for the code splitting.
export const routes = [
  {
    path: '/',
    component: resolve => require(['./components/Root.vue'], resolve),
    children: [
      {
        path: '/',
        alias: '/home',
        component: resolve => require(['./components/Home.vue'], resolve)
      },
      {
        path: '/admin',
        alias: '/admin/dashboard',
        meta: { adminOnly: true },
        component: resolve => require(['./components/admin/dashboard/Dashboard.vue'], resolve)
      },
      {
        path: '/admin/users',
        meta: { adminOnly: true },
        component: resolve => require(['./components/admin/users/Users.vue'], resolve)
      },
      {
        path: '/admin/locations',
        meta: { adminOnly: true },
        component: resolve => require(['./components/admin/locations/Locations.vue'], resolve)
      },
      {
        path: '/admin/buildings',
        meta: { adminOnly: true },
        component: resolve => require(['./components/admin/buildings/Buildings.vue'], resolve)
      },
      {
        path: '/admin/templates',
        meta: { adminOnly: true },
        component: resolve => require(['./components/admin/templates/Templates.vue'], resolve)
      },
      {
        path: '/template/:id',
        name: 'template',
        component: resolve => require(['./components/admin/templates/Template.vue'], resolve)
      },
      {
        path: '/audits',
        component: resolve => require(['./components/audits/Audits.vue'], resolve)
      },
      {
        path: '/audit/:id',
        name: 'audit',
        component: resolve => require(['./components/audits/Audit.vue'], resolve)
      },
      {
        path: '/login/:action?',
        component: resolve => require(['./components/Login.vue'], resolve),
        meta: { allowAnonymous: true }
      },
      {
        path: '/resetpassword/:token?',
        component: resolve => require(['./components/ResetPassword.vue'], resolve),
        meta: { allowAnonymous: true }
      }
    ]
  },
  {
    path: '/download-audit/:key?/:userID?',
    component: resolve => require(['./components/audits/DownloadAudit.vue'], resolve),
    meta: { allowAnonymous: true }
  },
  {
    path: '*',
    component: resolve => require(['./components/error-pages/404.vue'], resolve),
    meta: { allowAnonymous: true }
  }
]



// WEBPACK FOOTER //
// ./src/routes.js